import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ALL_CEREMONY_SLOT_TYPES_QUERY_KEY, CEREMONY_SLOT_TYPE_API_URL } from '@/constants';
import { apiUrl, getQueryParams } from '@/helpers';

export const ceremonySlotTypeEndpoints = {
  getAll: (organizationId?: number) =>
    axios.get(
      `${apiUrl()}${CEREMONY_SLOT_TYPE_API_URL}${getQueryParams({
        'filter.organizationId': organizationId as number
      })}`
    )
};

export const useGetAllCeremonySlotTypes = (organizationId?: number, enabled?: boolean) => {
  return useQuery(
    [ALL_CEREMONY_SLOT_TYPES_QUERY_KEY],
    () => ceremonySlotTypeEndpoints.getAll(organizationId),
    {
      keepPreviousData: true,
      enabled: enabled ?? true
    }
  );
};
